var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('MobileNav'),_c('SideNav'),_c('div',{attrs:{"id":"mask"}}),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTop animated fadeInDown"},[_c('a',[_c('div',{staticClass:"main_logo"})])])
}]

export { render, staticRenderFns }